import { css } from "@emotion/react";
import { styleUtils, theme } from "@minted/minted-components";

export const sharedSectionTypeStyles = {
  label: css`
    ${theme.typeStyles.bodySmallStyles};
    ${theme.typeStyles.bodyBoldStyles};
    flex-shrink: 0;
    max-width: ${styleUtils.rem(82)};
    flex-wrap: wrap;
  `,
  plainTextValue: css`
    ${theme.typeStyles.bodySmallStyles};
    // necessary for multiline overflow and ellipsis styling
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  readOnlyDescriptionGridLayout: css`
    display: grid;
    grid-template-columns: auto 1fr;
    row-gap: ${theme.spacing.x4};
    column-gap: ${theme.spacing.x4};
    overflow: hidden;
  `,
  row: css`
    align-items: center;
    display: flex;
    justify-content: space-between;
  `,
  sectionTitle: css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${theme.typeStyles.titleMediumStyles}
  `,

  singleImage: css`
    max-height: ${styleUtils.rem(120)};
    max-width: ${styleUtils.rem(120)};
  `,
  wrapper: css`
    border: ${styleUtils.rem(1)} solid ${theme.colors.gray300};
    border-radius: ${styleUtils.rem(5)};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.x2};
    margin-bottom: ${theme.spacing.x2};
    margin-top: ${theme.spacing.x2};
    padding: ${theme.spacing.x4};
  `,
};
